import api from "./api";
// @ts-expect-error - api is not typed
const { post } = api.getPrefixedMethods("files");
export const filesService = {
    getPresignedUrl: (fileName) => {
        return post("get-presigned-url/", { fileName });
    },
};
